<script setup lang="ts">
import AppLayout from "@/layouts/AppLayout.vue";
import { UConfirmHost } from "@brood/ui-kit";
</script>

<template>
  <AppLayout>
    <router-view />
  </AppLayout>
  <UConfirmHost />
</template>
